<template>
  <div class="bottomLinkModule">
      <div class="bottomLinkMenu">
        <div class="title">{{title}}</div>
            <ul class="account-nav">
                <li v-for="(item,i) in bottomLinks" :key='i' :class="{current:item.id===linkId}"
                    @click="tab(item.id)">{{item.title}}</li>
                <li :class="{current:-1===linkId}" @click="tab(-1)">用户反馈</li>
            </ul>
      </div>
      <div class="bottomLinkContent">
        <router-view></router-view>
      </div>
      <div class="clear">&nbsp;</div>
  </div>
</template>
<style>
@import '../../styles/bottomLink.css';
</style>
<script>
  import { getBottomLinks} from '@/api/bottomLink'
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        title: '文章',
        linkId:0,       
        bottomLinks:[],
        editAvatar: true
      }
    },
    computed: {
      ...mapState(['profile'])
    },
    mounted () {
    
    },
    methods: {    

    async _getBottomLinks()
    {
       await getBottomLinks().then(res=>{
            this.bottomLinks =  res.data.result.items
            for(var i=0;i<this.bottomLinks.length;i++)
            {
              var item = this.bottomLinks[i];
              if (item.id === this.tempId) {
                this.title = item.title          
              }
              if(this.tempId==0&&i==0)
              {
                 this.tempId=item.id;
                 this.title = item.title;
              }
            }         
        
        })
    },
    tab (tempId) {
        this.$router.push({path: '/bottomLink/Detail',query:{ id: tempId}})
      }
    },
    created () {
      var id = this.$route.query.id;  
      if(id)
      {
        this.linkId = parseInt(id)
      }
      debugger;
      this._getBottomLinks();
      
    },
    watch: {
      $route (to) {
        let path = to.path.split('/')[2]
        this.nav.forEach(item => {
          if (item.path === path) {
            this.title = item.name
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1c4c4f46